export const TOTAL_WORK_HOURS_SCRIPT_EXAMPLE = {
  title: 'Total Work Hours',
  description: 'Calculates total working hours for shift',
  code: `<div>
      {[
  Math?.ceil(
    Object?.keys(srcObj)?.reduce(
      (previousValue, currentKey) =>
        !Array.isArray(srcObj[currentKey])
          ? previousValue
          : previousValue +
            srcObj[currentKey]
              ?.filter(shift => shift?.duty_type_plan_ref === 'А' || !shift?.duty_type_plan_ref)
              ?.reduce(
                (prevValue, curValue) =>
                  prevValue +
                  ((curValue.duty_hours ? curValue.duty_hours / 60 : null) ||
                    (curValue.duty_hours_plan ? curValue.duty_hours_plan / 60 : 0)),
                0
              ),
      0
    )
  )
].map(val => (
        <div
          style={{
            backgroundColor:
              // Между датой начала и датой окончания ровно месяц
              moment?.(srcObj?.startDate)?.date() === 1 &&
              moment?.(srcObj?.endDate)?.isSame(moment(srcObj?.startDate), 'month') &&
              moment?.(srcObj?.endDate)?.isSame(moment(srcObj?.endDate)?.endOf('month'), 'day') &&
              // Сумма часов больше значения из справочника
              val > srcObj.variables?.roster_max_hours_dictionary2?.defaultValue?.[0]?.maxh
                ? '#e4717a'
                : '',
            color:
              // Между датой начала и датой окончания ровно месяц
              moment?.(srcObj?.startDate)?.date() === 1 &&
              moment?.(srcObj?.endDate)?.isSame(moment(srcObj?.startDate), 'month') &&
              moment?.(srcObj?.endDate)?.isSame(moment(srcObj?.endDate)?.endOf('month'), 'day') &&
              // Сумма часов больше значения из справочника
              val > srcObj.variables?.roster_max_hours_dictionary2?.defaultValue?.[0]?.maxh
                ? 'white'
                : 'black',
            marginLeft: -15,
            marginRight: -15,
            paddingLeft: 30,
          }}
        >
          {val}
        </div>
      ))}
    </div>`,
}

export const SHIFTS_COUNT_EXAMPLE = {
  title: 'Shifts Count',
  description: 'Counts the total number of work shifts for a person',
  code:
    'return Object.keys(srcObj).reduce((totalShifts, currentKey) => {\n' +
    "  // Игнорируем ключи 'id' и 'yElement'\n" +
    "  if (currentKey === 'id' || currentKey === 'yElement') return totalShifts;\n" +
    ' \n' +
    '  const currentArray = srcObj[currentKey];\n' +
    '  // Если значение - массив, добавляем его длину к общему количеству смен\n' +
    '  if (Array.isArray(currentArray)) {\n' +
    '    return totalShifts + currentArray.filter((shift)=>shift.duty_type_plan_ref === "А").length;\n' +
    '  }\n' +
    '  \n' +
    '  return totalShifts;\n' +
    '}, 0);',
}

export const VACATIONS_DAYS_COUNT_EXAMPLE = {
  title: 'Vacation Days Count',
  description: 'Counts the total number of vacation shifts for a person',
  code:
    'return Object.keys(srcObj).reduce((totalShifts, currentKey) => {\n' +
    "  // Игнорируем ключи 'id' и 'yElement'\n" +
    "  if (currentKey === 'id' || currentKey === 'yElement') return totalShifts;\n" +
    ' \n' +
    '  const currentArray = srcObj[currentKey];\n' +
    '  // Если значение - массив, добавляем его длину к общему количеству смен\n' +
    '  if (Array.isArray(currentArray)) {\n' +
    '    return totalShifts + currentArray.filter((shift)=>shift.duty_type_plan_ref === "ОТ").length;\n' +
    '  }\n' +
    '  \n' +
    '  return totalShifts;\n' +
    '}, 0);',
}

export const WORKING_HOURS_DEVIATION_EXAMPLE = {
  title: 'Working Hours Deviation',
  description:
    'Calculates the deviation between total working hours and the average expected hours',
  code:
    'const totalWorkingHours = Math?.ceil(\n' +
    '    Object?.keys(srcObj)?.reduce(\n' +
    '      (previousValue, currentKey) =>\n' +
    '        !Array.isArray(srcObj[currentKey])\n' +
    '          ? previousValue\n' +
    '          : previousValue +\n' +
    '            srcObj[currentKey]?.reduce(\n' +
    '                (prevValue, curValue) =>\n' +
    '                  prevValue +\n' +
    '                  ((curValue.duty_hours ? curValue.duty_hours / 60 : null) ||\n' +
    '                    (curValue.duty_hours_plan ? curValue.duty_hours_plan / 60 : 0)),\n' +
    '                0\n' +
    '              ),\n' +
    '      0\n' +
    '    )\n' +
    '  )\n' +
    '\n' +
    '  if (srcObj?.variables?.total_working_hours?.defaultValue === undefined) {\n' +
    "    return '-'\n" +
    '  }\n' +
    '\n' +
    '  const averageWorkingHours = (srcObj?.variables?.total_working_hours?.defaultValue / 60) / srcObj.objectYTotalCount\n' +
    '\n' +
    '  return Math.ceil(totalWorkingHours - averageWorkingHours)',
}

export const ROSTER_DUTY_RSQL_FILTER_EXAMPLE = {
  title: 'Roster Duty RSQL filter',
  description: 'Generate combined RSQL filter from date range and search assistant',
  code:
    'const dateFilter = `(duty_start=ge=${srcObj.startDate});(duty_start=le=${srcObj.endDate})`\n' +
    '\n' +
    "const shiftFilter = 'duty_type_plan_ref==А'\n" +
    '\n' +
    'const saFilters = srcObj.getRSqlBySearch(srcObj.objectYSAFilters?.map(item => {\n' +
    '        return {\n' +
    '          ...item,\n' +
    '          valueName: `staff_ref.${item.valueName}`,\n' +
    '        }\n' +
    '      }))\n' +
    '\n' +
    'const filters = [dateFilter]\n' +
    '\n' +
    'if (saFilters) {\n' +
    '  filters.push(saFilters)\n' +
    '}\n' +
    '\n' +
    'filters.push(shiftFilter)\n' +
    '\n' +
    "return filters.join(';')",
}

export const ROSTER_DUTY_DEFAULT_FILTER_EXAMPLE = {
  title: 'Roster duty default filter',
  description: 'Get default filter for view',
  code:
    "const dates = srcObj?.gridCellParams?.field?.slice(1, -1).split(';')\n" +
    '\n' +
    'return `staff_ref=in=("${srcObj?.gridCellParams?.row?.yElement?.internal_id}");duty_start=ge="${dates?.[0]}";duty_start=le="${dates?.[1]}"`',
}

export const AGGREGATION_COMMAND_RESULT_EXAMPLE = {
  title: 'Get aggregation command result',
  description: 'Extracts and returns the fact field from the first aggregated result record',
  code: 'return srcObj.commandData?.data?.[0]?.fact',
}

export const TIME_LINE_UPDATE_COMMAND_FOR_DROP_ACTION_GET_ID_EXAMPLE = {
  title: 'Get event _id',
  code: 'return srcObj.item._id',
}

export const ROSTER_DUTY_UPDATE_COMMAND_FOR_DROP_ACTION_GET_NEW_DUTY_START_EXAMPLE = {
  title: 'New duty_start',
  description: 'Set date from the target column; time stays from the old duty_start.',
  code: `return moment(srcObj.item.duty_start)
  .year(moment(srcObj.target.columnInfo.startDate).year())
  .month(moment(srcObj.target.columnInfo.startDate).month())
  .date(moment(srcObj.target.columnInfo.startDate).date())`,
}

export const ROSTER_DUTY_UPDATE_COMMAND_FOR_DROP_ACTION_GET_NEW_DUTY_END_EXAMPLE = {
  title: 'New duty_end',
  description: 'Set date from the target column',
  code: `const start = moment(srcObj.item.duty_start)
    const end = moment(srcObj.item.duty_end)

    const newDutyEnd = end
      .clone()
      .year(moment(srcObj.target.columnInfo.startDate).year())
      .month(moment(srcObj.target.columnInfo.startDate).month())
      .date(moment(srcObj.target.columnInfo.startDate).date())

    const daysBetween = end.diff(start, 'days')

    return newDutyEnd.clone().add(daysBetween, 'days')`,
}

export const ROSTER_DUTY_UPDATE_COMMAND_FOR_DROP_ACTION_GET_NEW_STAFF_REF_EXAMPLE = {
  title: 'New staff_ref',
  description: 'Target row id after drop.',
  code: `return srcObj.target.rowId`,
}

export const ROSTER_PERSON_QUALIFICATION_UPDATE_COMMAND_FOR_DROP_ACTION_GET_NEW_QUAL_ID = {
  title: 'New qualification id',
  code: `return srcObj.target.columnInfo.qual_id`,
}
